// Productpagina: opties worden op positie gelezen, nooit op hun vertaalde naam.
(() => {
  const root = document.querySelector("[data-product-root]");
  if (!root) return;

  const product = JSON.parse(root.querySelector("[data-product-json]").textContent);
  const strings = window.FS_T || {};
  const translate = (template, values = {}) => Object.entries(values).reduce(
    (text, [key, value]) => text.replaceAll(`__${key.toUpperCase()}__`, value),
    template || "",
  );
  const optionCount = product.options.length;
  const colourIndex = optionCount >= 2 ? 0 : -1;
  const sizeIndex = optionCount ? optionCount - 1 : -1;
  const showSizeTable = root.dataset.showSizeTable === "true";

  const colourValues = colourIndex < 0
    ? []
    : [...new Set(product.variants.map((variant) => variant.options[colourIndex]))];

  const colourMap = new Map(
    [...root.querySelectorAll("[data-colour][data-option-value]")]
      .map((button) => [button.dataset.optionValue.toLowerCase(), button.dataset.colour]),
  );

  function normalColour(value) {
    const name = String(value).toLowerCase();
    if (colourMap.has(name)) return colourMap.get(name);
    return colourValues.indexOf(value) === 1 ? "black" : "white";
  }

  const params = new URLSearchParams(location.search);
  // ?color=black|white, en oudere links met ?kleur=zwart|wit.
  const legacyColour = { zwart: "black", wit: "white" }[params.get("kleur")?.toLowerCase()];
  const requestedColour = params.get("color")?.toLowerCase() || legacyColour;
  let colour = ["black", "white"].includes(requestedColour) ? requestedColour : root.dataset.defaultColour;
  let size = null;

  const colourButtons = [...root.querySelectorAll("[data-colour]")];
  if (colourButtons.length && !colourButtons.some((button) => button.dataset.colour === colour)) {
    colour = colourButtons[0].dataset.colour;
  }

  const sizeButtons = [...root.querySelectorAll("[data-size]")];
  const fit = root.querySelector("[data-fit]");
  const hiddenVariant = root.querySelector("[data-variant-id]");
  const buy = root.querySelector("[data-buy]");
  const barBuy = root.querySelector("[data-bar-buy]");
  if (hiddenVariant) hiddenVariant.disabled = false;

  const colourMatches = (variant, key) => colourIndex < 0 || normalColour(variant.options[colourIndex]) === key;
  const sizeMatches = (variant, value) => sizeIndex < 0 || variant.options[sizeIndex] === value;
  const chosenVariant = () => product.variants.find((variant) => colourMatches(variant, colour) && sizeMatches(variant, size));

  function updateGallery() {
    const figures = [...root.querySelectorAll("[data-gallery-colour]")];
    const hasSelectedColour = figures.some((figure) => figure.dataset.galleryColour === colour);
    figures.forEach((figure) => {
      figure.hidden = hasSelectedColour && figure.dataset.galleryColour !== colour;
    });
  }

  function updateFit() {
    if (!fit) return;

    const measures = { S: [55, 73], M: [58, 76], L: [61, 78], XL: [64, 80] };
    if (size && showSizeTable && measures[size]) {
      fit.textContent = translate(strings.fitMeasurements, { size, width: measures[size][0], length: measures[size][1] });
    } else if (size) {
      fit.textContent = translate(strings.fitSelected, { size });
    } else {
      fit.textContent = root.dataset.fitText || (showSizeTable
        ? strings.fitWithSizes
        : strings.fit);
    }
    fit.classList.remove("is-asking");
  }

  function update() {
    const variant = chosenVariant();
    if (variant && hiddenVariant) hiddenVariant.value = variant.id;

    sizeButtons.forEach((button) => {
      const matchingVariant = product.variants.some((item) => (
        colourMatches(item, colour)
        && sizeMatches(item, button.dataset.size)
        && item.available
      ));
      button.disabled = !matchingVariant;
      button.setAttribute("aria-pressed", String(button.dataset.size === size));
    });

    updateFit();

    const ready = sizeIndex < 0 || Boolean(size);
    const label = ready
      ? translate(strings.addToBag, { price: root.dataset.priceOverride || formatMoney(variant?.price ?? product.price) })
      : strings.chooseSize;
    if (buy) buy.textContent = label;
    if (barBuy) barBuy.textContent = label;

    const table = root.querySelector("[data-size-table]");
    if (table) {
      const headings = ["", "S", "M", "L", "XL"];
      table.querySelectorAll("th, td").forEach((cell) => {
        cell.classList.toggle("is-on", Boolean(size) && cell.cellIndex === headings.indexOf(size));
      });
    }

    updateGallery();
    colourButtons.forEach((button) => {
      button.setAttribute("aria-pressed", String(button.dataset.colour === colour));
    });

    const colourName = root.querySelector("[data-colour-name]");
    if (colourName) colourName.textContent = colour === "black" ? strings.black : strings.white;

    const meta = root.querySelector("[data-bar-meta]");
    if (meta) {
      meta.textContent = [
        colourIndex >= 0 ? (colour === "black" ? strings.black : strings.white) : "",
        size,
      ].filter(Boolean).join(", ");
    }
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "nl-NL", {
        style: "currency",
        currency: Shopify.currency.active,
        minimumFractionDigits: cents % 100 ? 2 : 0,
      }).format(cents / 100);
    } catch {
      return `€${cents / 100}`;
    }
  }

  colourButtons.forEach((button) => {
    button.addEventListener("click", () => {
      colour = button.dataset.colour;
      const selectedStillAvailable = size && product.variants.some((variant) => (
        colourMatches(variant, colour)
        && sizeMatches(variant, size)
        && variant.available
      ));
      if (size && !selectedStillAvailable) size = null;

      const url = new URL(location.href);
      url.searchParams.set("color", colour);
      history.replaceState(null, "", url);
      update();
      root.querySelector("[data-gallery]")?.scrollTo(0, 0);
    });
  });

  sizeButtons.forEach((button) => {
    button.addEventListener("click", () => {
      size = button.dataset.size;
      update();
    });
  });

  root.querySelector(".product-form")?.addEventListener("submit", (event) => {
    if (sizeIndex >= 0 && !size) {
      event.preventDefault();
      fit.textContent = strings.selectSizeFirst;
      fit.classList.add("is-asking");
      sizeButtons.find((button) => !button.disabled)?.focus();
    }
  });

  barBuy?.addEventListener("click", () => {
    if (sizeIndex >= 0 && !size) {
      fit.textContent = strings.selectSizeFirst;
      fit.classList.add("is-asking");
      root.querySelector(".pdp-sizes")?.scrollIntoView({ behavior: "smooth", block: "center" });
      sizeButtons.find((button) => !button.disabled)?.focus();
    } else {
      buy?.click();
    }
  });

  if (buy && barBuy && "IntersectionObserver" in window) {
    new IntersectionObserver(([entry]) => {
      root.querySelector("[data-bar]").hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }).observe(buy);
  }

  update();
})();
